import GenericFilter from "./GenericFilter";
import { STAGE_COLOR_MAP } from "../../../lib/constants";
import type { Filters, FilterOptions, UpdateFilterFn, ToggleArrayFilterFn } from "../types";

type Props = {
  filters: Filters;
  filterOptions: FilterOptions;
  updateFilter: UpdateFilterFn;
  toggleArrayFilter: ToggleArrayFilterFn;
  isMobile: boolean;
  isActive: boolean;
};

const PhaseFilters = ({
  filters,
  filterOptions,
  updateFilter,
  toggleArrayFilter,
  isMobile,
  isActive,
}: Props) => {
  return (
    <GenericFilter
      filterKey="phases"
      selectedValues={filters.phases}
      availableValues={filterOptions.phases ?? []}
      colorMap={STAGE_COLOR_MAP}
      updateFilter={updateFilter}
      toggleArrayFilter={toggleArrayFilter}
      isMobile={isMobile}
      isActive={isActive}
      radioName="phase-radio"
    />
  );
};

export default PhaseFilters;
